export default "__VITE_ASSET__B4lCl92H__"